// @ts-strict-ignore
import { Component, Input, OnInit } from '@angular/core';
import { LMFormRequestService } from '@form/services/lm-form-request.service';
import { LMHtmlPageUtilService } from '@html/lm-html-page-util.service';
import { LMApplicationMenuUserContextResult } from './lm-application-menu-usercontext-dialog.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'lm-application-menu-user-context',
  standalone: false,
  templateUrl: 'lm-application-menu-usercontext-dialog.component.html',
  providers: [ LMFormRequestService, LMHtmlPageUtilService ]
})
export class LMApplicationMenuUserContextDialogComponent implements OnInit {
  @Input() userContextFields: LMApplicationMenuUserContextField[];
  @Input() dialog$: Subject<LMApplicationMenuUserContextResult>;

  contextFields: any;
  busyIndicator: boolean;
  model: { [ key: string ]: LMApplicationMenuUserContextModelField };

  get saveChanges(): boolean {
    const save = false;

    const modelKeys = Object.keys(this.model);
    for (let i = 0; i < modelKeys.length; i++) {
      if (this.model[ modelKeys[ i ] ].dirty) {
        return true;
      }
    }

    return save;
  }

  constructor() {}

  ngOnInit() {
    this.model = {};

    if (this.userContextFields) {
      this.userContextFields.forEach((contextField: any) => {
        this.model [ contextField.contextPropertyId ] = {
          dirty: false,
          value: contextField.value
        };
      });
    }
  }

  public onContextValueChanged(field: LMApplicationMenuUserContextField) {
    this.model [ field.contextPropertyId ].value = field.value;
  }

  public onModelDirty(modelFieldDirty: any) {
    const dirty = modelFieldDirty.dirty;
    const field = modelFieldDirty.field;

    this.model [ field.contextPropertyId ].dirty = dirty;
  }
}
